import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-eye-2-line text-lg" />
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">
              反差<em className="not-italic text-primary-600">追踪</em>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            一家面向中文读者的身份与信息来源梳理站点，长期跟踪「反差」类网络事件的主角与当事人线索。我们强调交叉验证、信源标注与理性看待，不替任何观点站队。
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900">栏目导航</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              { label: "主角档案", to: "/renwu" },
              { label: "事件溯源资讯", to: "/zixun" },
              { label: "最新动态", to: "/zixun" },
            ].map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-foreground-600 transition-colors hover:text-primary-700">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900">了解本站</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-700">
                立场与编辑原则
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-700">
                常见问题
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-700">
                联系方式
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 反差追踪 · 仅供学习与信息参考，不构成对任何个体的定论。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line" />
            信息来自公开渠道，请理性看待。
          </p>
        </div>
      </div>
    </footer>
  );
}